const configuredApiUrl = process.env.REACT_APP_API_URL;
const API_BASE_URL =
  configuredApiUrl !== undefined
    ? configuredApiUrl
    : window.location.hostname === 'localhost'
      ? 'http://localhost:3002'
      : '';
const TOKEN_KEY = 'niche_data_token';

function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function isAuthenticated(): boolean {
  return !!getToken();
}

async function request(path: string, options: RequestInit = {}) {
  const token = getToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options.headers as Record<string, string> || {})
  };

  const res = await fetch(`${API_BASE_URL}${path}`, { ...options, headers });

  if (res.status === 401) {
    clearToken();
    window.location.href = '/';
    throw new Error('Session expired');
  }

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Request failed: ${res.status}`);
  }

  return res.json();
}

export const api = {
  login: (password: string) =>
    request('/api/auth/login', { method: 'POST', body: JSON.stringify({ password }) }),

  getSystemHealth: () =>
    request('/api/system-health'),

  getThroughputSeries: (window: string) =>
    request(`/api/system-health/throughput-series?window=${encodeURIComponent(window)}`),

  getQueueStats: () =>
    request('/api/queue-stats'),

  getInfraHealth: (window: string) =>
    request(`/api/infra-health?window=${encodeURIComponent(window)}`),

  getTargets: (params: Record<string, string | number>) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v) qs.set(k, String(v)); });
    return request(`/api/targets?${qs}`);
  },

  getJobs: (params: Record<string, string | number>) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v) qs.set(k, String(v)); });
    return request(`/api/jobs?${qs}`);
  },

  getJobDetail: (id: number) =>
    request(`/api/jobs/${id}`),

  getPlatforms: () =>
    request('/api/platforms'),
};
